import { ViewHeader2Page } from "./../view-header2/view-header2";
import { Storage } from "@ionic/storage";
import { WaitStep2Page } from "./../wait-step2/wait-step2";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-select-team",
  templateUrl: "shopper-select-team.html",
})
export class ShopperSelectTeamPage {
  lists: any;
  shopperActive: any;
  theme = 1;

  constructor(
    private services: ServiceProvider,
    private http: Http,
    private navCrl: NavController,
    private storage: Storage,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      this.storage.get("info").then((info) => {
        this.shopperActive = info.team.shopper_id;

        var link = this.services.URLShopperList;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.lists = data.filter(
                (item) => item.shopper_id == this.shopperActive
              );
              loader.dismiss();
            },
            (error) => {
              var response = JSON.parse(error._body);
              loader.dismiss();
              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );
      });
    });
  }

  select(id) {
    this.shopperActive = id;
    console.log(this.shopperActive);
  }

  next() {
    if (this.shopperActive == "" || !this.shopperActive) {
      this.translateService.get("error select team").subscribe((value) => {
        this.services.presentToast(value);
        return false;
      });
    } else {
      const loader = this.loadingCtrl.create({
        content: "Loading...",
      });
      loader.present();

      this.storage.get("token").then((token) => {
        this.storage.get("info").then((info) => {
          let body = "shopper_id=" + this.shopperActive;

          var link = this.services.URLShopperTeam;
          var headers = new Headers();
          headers.append("Content-Type", "application/x-www-form-urlencoded");
          headers.append("Accept", "application/json");
          headers.append("Authorization", "Bearer " + token);
          const requestOptions = new RequestOptions({ headers: headers });

          this.http
            .post(link, body, requestOptions)
            .map((res) => res.json())
            .subscribe(
              (data) => {
                var link3 = this.services.URLUserInfo;
                var headers2 = new Headers();
                headers2.append("Accept", "application/json");
                headers2.append("Authorization", "Bearer " + token);
                const requestOptions2 = new RequestOptions({
                  headers: headers2,
                });

                this.http
                  .get(link3, requestOptions2)
                  .map((res) => res.json())
                  .subscribe(
                    (res) => {
                      this.storage.set("info", res);

                      var link2 = this.services.URLUserStatEnd;
                      this.http
                        .post(link2, "", requestOptions)
                        .map((res) => res.json())
                        .subscribe((data2) => {
                          this.storage.set("stepGame", "waitStep2");
                          loader.dismiss();
                          this.navCrl.push(WaitStep2Page);
                        });
                    },
                    (error) => {
                      var response = JSON.parse(error._body);
                      loader.dismiss();
                      this.translateService
                        .get(response.message)
                        .subscribe((value) => {
                          this.services.presentToast(value);
                        });
                    }
                  );
              },
              (error) => {
                this.shopperActive = "";
                var response = JSON.parse(error._body);
                loader.dismiss();
                this.translateService
                  .get(response.message)
                  .subscribe((value) => {
                    this.services.presentToast(value);
                  });
              }
            );
        });
      });
    }
  }

  openHeadPage() {
    this.navCrl.push(ViewHeader2Page);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-select-team/shopper-select-team.ts